var Collection      = require("Collection"),
    ol              = require("openlayers"),
    $               = require("jquery");

var LayerCollection = Collection.extend({

    initialize: function(view, objects, options){
        var that = this;

        if (!view) {
            throw new Error('Can not initialize LayerCollection without view instance');
        }
        that._view = view;

        LayerCollection.__super__.initialize.call(that, objects, options);
    },

    add: function(layers){
        var that = this,
            _layers,
            i;

        LayerCollection.__super__.add.call(that, layers);

        _layers = $.isArray(layers) ? layers : [layers];

        for(i in _layers) {
            if (_layers[i] && 'getMapLayer' in _layers[i]) {
                that._olLayersGroup.getLayers().push(_layers[i].getMapLayer());
                _layers[i].onAdd(that._view);
            }
        }
    },

    remove: function(layers){
        var that = this,
            _layers,
            i;

        LayerCollection.__super__.remove.call(that, _layers);

        _layers = $.isArray(layers) ? layers : [layers];

        for (i in _layers) {
            if (_layers[i] && 'getMapLayer' in _layers[i]) {
                that._olLayersGroup.getLayers().remove(_layers[i].getMapLayer());
            }
        }
    },

    reset: function(objects){
        var that = this;

        if (that._olLayersGroup instanceof ol.layer.Group) {
            that._olLayersGroup.getLayers().clear();
        } else {
            that._olLayersGroup = new ol.layer.Group({});
        }

        return LayerCollection.__super__.reset.call(that, objects);
    },

    /**
     *
     */
    filter: function(predicate){
        var that = this,
            result = [],
            callback;

        callback = $.isFunction(predicate)
            ? predicate
            : function() {
                return true;
            };

        that._items.forEach(function(obj, i) {
            if (callback (obj, i)) {
                result.push(obj);
            }
        });

        return new Collection(result);
    },

    /**
     *
     */
    getByContainerCodes: function(codes){
        var that = this;
        var _codes;

        if (typeof codes === 'string') {
            _codes = codes.trim().split(' ');
        } else {
            _codes = codes;
        }

        return that.filter(function(layer) {
            var contCodes = layer.getProjectLayers().getArray().map(function(cont){
                return cont.get('code');
            });

            return _.intersection(_codes, contCodes).length;
        });
    }
});

module.exports = LayerCollection;



//////////////////
// WEBPACK FOOTER
// ./src/View/LayerCollection.js
// module id = 40
// module chunks = 0